<template>
  <div>
    <v-fab-transition>
      <v-badge
        bordered
        color="white"
        overlap
        :style="COMPUTED_STYLE_BTN_TABELA"
        v-if="COMPUTED_SELECIONADOS.length > 0"
      >
        <template v-slot:badge>
          <span style="color: #000000">{{ COMPUTED_SELECIONADOS.length }}</span>
        </template>

        <v-btn
          small
          color="success"
          @click="adicionarProdutosNaLista()"
        >
          <v-icon class="mr-1" small>mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </v-badge>
    </v-fab-transition>

    <v-fab-transition>
      <v-btn
        color="success"
        small
        :style="COMPUTED_STYLE_BTN_RESTAURAR"
        v-if="restaurar_grafico"
        @click="restaurarGrafico()"
      >
        Restaurar Grafico <v-icon class="ml-1" small>mdi-reload</v-icon>
      </v-btn>
    </v-fab-transition>

    <DetalheProdutoSazonalidade :produto="click_item" />

    <Combinar />

    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Pesquisar"
      hide-details
      clearable
      dense
      outlined
      style="width: 450px; position: absolute; top: 0; right: 0; margin: 70px 30px 0px 0px !important;"
    />

    <sys-data-table
      v-model="COMPUTED_SELECIONADOS"
      :headers="GET_HEADERS_TABELA"
      :items="GET_DADOS_TABELA"
      :height="alturaDaJanela - 534"
      :item-height="35"
      item-key="idproduto"
      show-select
      class="px-1"
      :search="search"
      @click:row="itemSelecinadoGrafico"
    >
      <template #item.descricao_produto="{ item }">
        <v-btn icon x-small @click="abrirDialogDetalheProduto(item)">
          <v-icon :size="17">mdi-information-outline</v-icon>
        </v-btn>
        {{ item.descricao_produto }}
      </template>

      <template #item.estoque="{ value }">{{ Helpers.formatarValor(value) }}</template>

      <template #item.media_tres_meses="{ value }">{{ Helpers.formatarValor(value) }}</template>

      <template #item.preco_venda_evento_estatico="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

      <template #item.markup_evento_estatico="{ value }">{{ Helpers.formatarValor(value) }}%</template>

      <template #item.quantidade_evento_estatico="{ value }">{{ Helpers.formatarValor(value) }}</template>

      <template #item.faturamento_evento_estatico="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

      <template #item.preco_custo_evento="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

      <template #item.acrescimo="{ item }">
        <TextFieldFormatadorDeValor
          v-model="item.acrescimo"
          class="text-field-centralizado font-12"
          suffix="%"
          :maxDigitos="2"
          @input="aplicarAcrescimo(item)"
        />
      </template>

      <template #item.desconto="{ item }">
        <TextFieldFormatadorDeValor
          v-model="item.desconto"
          class="text-field-centralizado font-12"
          suffix="%"
          :maxDigitos="2"
          @input="aplicarDesconto(item)"
        />
      </template>

      <template #item.preco_venda_evento="{ item }">
        <TextFieldFormatadorDeValor
          v-model="item.preco_venda_evento"
          class="text-field-centralizado font-12"
          :maxDigitos="2"
          prefix="R$"
          @input="aplicarPrecoVenda(item)"
        />
      </template>

      <template #item.markup_evento="{ item }">
        <TextFieldFormatadorDeValor
          v-model="item.markup_evento"
          class="text-field-centralizado font-12"
          :maxDigitos="2"
          suffix="%"
          @input="aplicarMarkup(item)"
        />
      </template>

      <template #item.quantidade_evento="{ item }">
        <TextFieldFormatadorDeValor
          v-model="item.quantidade_evento"
          class="text-field-centralizado font-12"
          :maxDigitos="2"
          @input="aplicarMetaQuantidade(item)"
        />
      </template>

      <template #item.faturamento_evento="{ item }">
        <TextFieldFormatadorDeValor
          v-model="item.faturamento_evento"
          class="text-field-centralizado font-12"
          :maxDigitos="2"
          prefix="R$"
          @click="aplicarMetaFaturamento(item)"
        />
      </template>

      <template #footer.prepend>
        <strong>
          {{ COMPUTED_TOTAL_FATURADO_PERIODO }}
        </strong>
      </template>
    </sys-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Responsividade from '@/helpers/ResponsiveHeight';
import Combinar from './Combinar.vue';
import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue';
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import DetalheProdutoSazonalidade from '../../Detalhes/Index.vue';

export default {
  mixins: [Responsividade],
  components: {
    Combinar,
    Responsividade,
    SysDialogFullScreen,
    TextFieldFormatadorDeValor,
    DetalheProdutoSazonalidade,
  },
  data: () => ({
    restaurar_grafico: false,
    ultimo_idproduto_selecionado: '',
    search: '',
    click_item: {}
  }),
  mounted() {
    this.buscarDadosTabela();
  },
  watch: {
    GET_DIALOG_GRAFICO_TABELA(valor) {
      if (valor) this.buscarDadosTabela();
    }
  },
  computed: {
    ...mapGetters({
      GET_HEADERS_TABELA: 'EventoSazonalFinal/GET_HEADERS_TABELA',
      GET_DADOS_TABELA: 'EventoSazonalFinal/GET_DADOS_TABELA',
      GET_SELECIONADOS_DADOS_TABELA: 'EventoSazonalFinal/GET_SELECIONADOS_DADOS_TABELA',
      GET_DIALOG_GRAFICO_TABELA: 'EventoSazonalFinal/GET_DIALOG_GRAFICO_TABELA',
    }),
    COMPUTED_SELECIONADOS: {
      get() { return this.GET_SELECIONADOS_DADOS_TABELA; },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setSelecionadosDadosTabela', value); }
    },
    COMPUTED_TOTAL_FATURADO_PERIODO() {
      const numbers = this.GET_DADOS_TABELA.map(map => map.faturamento_evento);
      const sum = numbers.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue), 0);
      return `Total faturado no periodo é de ` + this.Helpers.formatarValorMonetario(sum);
    },
    COMPUTED_STYLE_BTN_TABELA() {
      return {
        zIndex: '999',
        position: 'absolute',
        right: 0,
        top: 0,
        marginTop: '16px',
        marginRight: '188px'
      }
    },
    COMPUTED_STYLE_BTN_RESTAURAR() {
      return {
        zIndex: '999',
        position: 'absolute',
        right: 0,
        top: 0,
        marginTop: '115px',
        marginRight: '30px'
      }
    }
  },
  methods:{
    buscarDadosTabela() {
      this.$store.dispatch('EventoSazonalFinal/buscarDadosTabela');
    },
    adicionarProdutosNaLista() {
      this.$store.dispatch('EventoSazonalFinal/adicionarProdutosNaLista');
    },
    itemSelecinadoGrafico(item) {
      this.restaurar_grafico = true;
      const selecionado = item.row;
      if (selecionado == this.ultimo_idproduto_selecionado) return;
      this.ultimo_idproduto_selecionado = selecionado;
      this.$store.dispatch('EventoSazonalFinal/buscarDadosGrafico', selecionado.idproduto);
    },
    aplicarAcrescimo(item) {
      item.desconto = 0;

      const preco_venda = Number(item.old.preco_venda_evento) == Number(item.preco_venda_evento)
        ? Number(item.preco_venda_evento)
        : Number(item.old.preco_venda_evento);

      item.preco_venda_evento = preco_venda + (preco_venda * (item.acrescimo / 100));
      item.markup_evento = ((item.preco_venda_evento / item.preco_custo_evento) - 1) * 100;
      item.faturamento_evento = item.preco_venda_evento * item.quantidade_evento;
    },
    aplicarDesconto(item) {
      item.acrescimo = 0;

      const preco_venda = Number(item.old.preco_venda_evento) == Number(item.preco_venda_evento)
        ? Number(item.preco_venda_evento)
        : Number(item.old.preco_venda_evento);

      item.preco_venda_evento = preco_venda - (preco_venda * (item.desconto / 100));
      item.markup_evento = ((item.preco_venda_evento / item.preco_custo_evento) - 1) * 100;
      item.faturamento_evento = item.preco_venda_evento * item.quantidade_evento;
    },
    aplicarPrecoVenda(item){
      item.markup_evento = ((item.preco_venda_evento / item.preco_custo_evento) - 1) * 100;
      item.faturamento_evento = item.preco_venda_evento * item.quantidade_evento;

      const info = ((item.preco_venda_evento - item.old.preco_venda_evento) / item.old.preco_venda_evento) * 100

      if (info > 0) {
        item.acrescimo = info;
        item.desconto = 0;
      } else {
        item.desconto = -info;
        item.acrescimo = 0;
      }
    },
    aplicarMarkup(item) {
      const preco_custo = item.old.preco_custo_evento;

      item.preco_venda_evento = Number(preco_custo) + Number(preco_custo * (item.markup_evento / 100));

      const info = ((item.preco_venda_evento - item.old.preco_venda_evento) / item.old.preco_venda_evento) * 100;

      if (info > 0) {
        item.acrescimo = info;
        item.desconto = 0;
      } else {
        item.desconto = -info;
        item.acrescimo = 0;
      }
    },
    aplicarMetaQuantidade(item) {
      item.faturamento_evento = item.quantidade_evento * item.preco_venda_evento;
    },
    aplicarMetaFaturamento(item) {
      item.quantidade_evento = item.faturamento_evento / item.preco_venda_evento;
    },
    restaurarGrafico() {
      this.restaurar_grafico = false;
      this.$store.dispatch('EventoSazonalFinal/buscarDadosGrafico')
    },
    abrirDialogDetalheProduto(item) {
      this.click_item = item;
    }
  }
}
</script>

<style>

</style>
